export default __webpack_public_path__ + "static/media/task.6557ed06.svg";